import { AttributeSpecCoreBase } from "./attribute-spec.core.base"


export class AttributeSpecCore extends AttributeSpecCoreBase {

}